/**
 * The default composer → create-body mapping.
 *
 * Lives in `_libs` rather than inside the composer component because surfaces that
 * ATTACH a field (a visit scenario, a support audience) need the same base mapping —
 * a second copy of "content becomes `comment`, attachments and audio become `uploads`"
 * would drift the first time either list gains a kind.
 */

import type { ChatComposerValues } from "@/features/shared/chat-composer";
import type { CreateChannelMessageInput } from "../_api/channel-endpoints";

/** Plain chat: text plus every finalized upload, audio included. */
export function buildDefaultChannelMessageInput(
  values: ChatComposerValues,
): CreateChannelMessageInput {
  return {
    comment: values.content,
    uploads: [
      ...values.attachments.map((attachment) => attachment.id),
      ...values.audios.map((audio) => audio.id),
    ],
  } as CreateChannelMessageInput;
}
